/**
 * «이미 KOLs DB 에 있는 크리에이터» 갱신 때 고칠 줄을 **정확히** 고른다.
 *
 * 2026-10-12 개발사 흔적 점검 F12: 닉네임 검색은 «포함» 검색이라 「abc」를 찾으면 「abc_beauty」도 나오는데,
 * 개발사 코드는 결과의 첫 줄을 골라 팔로워를 고쳤다(다른 KOL 팔로워가 바뀔 수 있음). 갱신하지 못해도 «최신화»라고 알렸다.
 * 같은 플랫폼이면서 계정 id·프로필 주소·대표 닉네임이 정확히 같은 줄만 고른다. 못 찾으면 null.
 */
const norm = (s) => String(s || '').trim().replace(/^@/, '').replace(/\/+$/, '').toLowerCase();
const platformKey = (p) => {
  const s = String(p || '').toLowerCase();
  if (s.includes('tiktok') || s === 'tt') return 'tiktok';
  if (s.includes('insta') || s === 'ig') return 'instagram';
  if (s.includes('youtube') || s === 'yt') return 'youtube';
  return s;
};
const lastPathPart = (url) => norm(String(url || '').split('?')[0].split('/').filter(Boolean).pop());

export function pickExactCreatorRow(rows, item) {
  const handle = norm(item?.handle);
  if (!handle) return null;
  const wantPlatform = platformKey(item?.platform);
  const samePlatform = (r) => {
    const p = platformKey(r?.platformInfo?.platformType || r?.platformType || r?.platform);
    return !wantPlatform || !p || p === wantPlatform;
  };
  const sameAccount = (r) => {
    const info = r?.platformInfo || r || {};
    return norm(info.profileId) === handle
      || norm(info.username) === handle
      || lastPathPart(info.profileUrl) === handle
      || norm(r?.representativeNickname) === handle;
  };
  return (rows || []).find((r) => r?.platformId && samePlatform(r) && sameAccount(r)) || null;
}
